import { Controller } from "@hotwired/stimulus"
import { formatLocalDateTime } from "../helpers/datetime"

export default class extends Controller {
  static values = {
    format: { type: String, default: "short" },
    locale: String
  }

  connect() {
    const iso = this.element.getAttribute("datetime")
    const text = formatLocalDateTime(iso, this.localeValue, this.formatValue)
    if (text) this.element.textContent = text
  }
}
